import { HeaderGroup, flexRender } from '@tanstack/react-table';
import { StyledTableDataDiv, StyledTableHeader, StyledTableRow } from '../../../../shared/styles/components/table.styles';

import React from 'react';
import { TableHeader as SkapaTableHeader } from '@ingka/table';
import { SortLabel } from '../table/SortLabel';
import { StatusSortMenu } from './StatusSortMenu';
import { StyledTooltip } from '../../../../shared/styles/components/integrations.styles';
import { SubItem } from '../../types/sub-item.types';
import styled from '@emotion/styled';

type ExpandedTableHeaderProps = {
   headerGroups: HeaderGroup<SubItem>[];
   subItems: SubItem[];
   parentIndex: number;
};

export const ExpandedTableHeader = ({ headerGroups }: ExpandedTableHeaderProps) => {
   return (
      <SkapaTableHeader>
         {headerGroups.map((headerGroup) => (
            <StyledTableRow key={headerGroup.id} noHover={true}>
               {headerGroup.headers.map((header, index) => {
                  const isRightAligned = header.column.columnDef.meta?.rightAligned;
                  return (
                     <StyledExpandedTableHeader
                        key={header.id}
                        colSpan={header.colSpan}
                        width={header.column.columnDef.meta?.width}
                        style={{
                           textAlign: isRightAligned ? 'right' : 'left'
                        }}
                        {...{
                           className: header.column.getCanSort() ? 'cursor-pointer select-none' : '',
                           onClick: (e) => {
                              if (index !== 0) header.column.getToggleSortingHandler()!(e);
                           },
                        }}
                     >
                        {index === 0 && <StatusSortMenu />}
                        {index !== 0 && (
                           <StyledTableDataDiv
                              style={{
                                 justifyContent: isRightAligned ? 'flex-end' : 'flex-start',
                                 width: '100%'
                              }}>
                              <StyledTooltip title={index !== 0 ? 'Toggle sort' : ''} placement="top">
                                 <StyledSortWrapperDiv>
                                    {isRightAligned && header.column.getCanSort() && (
                                       <SortLabel
                                          isSortedDesc={
                                             header.column.getIsSorted() === false ? undefined : header.column.getIsSorted() === 'desc'
                                          }
                                       />
                                    )}
                                    {flexRender(header.column.columnDef.header, header.getContext())}
                                    {!isRightAligned && header.column.getCanSort() && (
                                       <SortLabel
                                          isSortedDesc={
                                             header.column.getIsSorted() === false ? undefined : header.column.getIsSorted() === 'desc'
                                          }
                                       />
                                    )}
                                 </StyledSortWrapperDiv>
                              </StyledTooltip>
                           </StyledTableDataDiv>
                        )}
                     </StyledExpandedTableHeader>
                  );
               })}
            </StyledTableRow>
         ))}
      </SkapaTableHeader>
   );
};

export const StyledSortWrapperDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const StyledExpandedTableHeader = styled(StyledTableHeader)`
  z-index: -1 !important;
  padding-bottom: 0.75rem !important;
`;
